export const legacyStrings = {
  UURLTestTool_Url_Expand_Button: _TL_('Expand'),
  UURLTestTool_Url_Collapse_Button: _TL_('Collapse'),
  LearnMore: _TL_('Learn more'),
  UURLTestTool_Title_ServingURL: _TL_('Click URL'),
  UURLTestTool_Title_TrackingTemplate: _TL_('Tracking Template'),
  UURLTestTool_Title_FinalURLSuffix: _TL_('Final URL suffix'),
  UURLTestTool_Title_FinalURL: _TL_('Final URL'),
  UURLTestTool_Title_AttributeUsed: _TL_('Attribute Used'),
  UURLTestTool_Note_Title: _TL_('Note'),
  UURLTestTool_Note: _TL_('This test does not check for Microsoft Advertising policy violations.'),
  UURLTestTool_With_ParallelTracking: _TL_('With parallel tracking:'),
  UURLTestTool_LandingPage_URL: _TL_('Landing page URL:'),
  UURLTestTool_Tracking_URL: _TL_('Tracking URL:'),
  UURLTestTool_When_ParallelTracking_Is_Not_Supported: _TL_('When parallel tracking is not supported:'),
  UURLTestTool_Title_TrackingTemplate_Colon: _TL_('Tracking template:'),
  UURLTestTool_Title_TrackingTemplate_None: _TL_('(None)'),
  UURLTestTool_ClickURLs: _TL_('Click URLs'),
  UURLTestTool_Status: _TL_('Status'),
  UURLTestTool_AdGroup: _TL_('Ad Group'),
  UURLTestTool_Test_Button: _TL_('Test'),
  UURLTestTool_Test_Inprogress: _TL_('Testing in progress. We’ll have the results for you shortly.'),
  UURLTestTool_Result_ShowDetails: _TL_('Click to show details of test result'),
  UURLTestTool_From: _TL_(' (from {0})'),
  UURLTestTool_NA: _TL_('N/A'),
  UURLTestTool_Result_Found: _TL_('Landing page found'),
  UURLTestTool_Result_NotFound: _TL_('Page not found'),
  UURLTestTool_Result_Mismatch: _TL_('Final URL mismatch'),
  UURLTestTool_Result_Unreachable: _TL_('Unreachable'),
  UURLTestTool_Result_Unknown: _TL_('Unknown/Tool failure'),
  UURLTestTool_Result_UserInputError: _TL_('In order to use URL options (tracking template and custom parameters), a final URL must be used.'),
  UURLTestTool_Result_NoEligibleUrlsFound: _TL_('No eligible URLs found'),
  UURLTestTool_Result_TestComplete: _TL_('Test complete'),
  UURLTestTool_TrackingCall_Successful: _TL_('Tracking call successful'),
  UURLTestTool_TrackingCall_Unsuccessful: _TL_('Tracking call unsuccessful'),
  Unkown: _TL_('Unkown'),
  Entity_Account: _TL_('Account'),
  Entity_Campaign: _TL_('Campaign'),
  Entity_Adgroup: _TL_('Ad group'),
  Entity_Ads: _TL_('Ad'),
  Entity_Keywords: _TL_('Keyword'),
  Entity_SitelinkExtensions: _TL_('Sitelink Extension'),
  Popup_Close: _TL_('Close'),
};
